import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TruckDetails({
    label,
    truckOptions,
    plateNumber,
    supplierId,
    onChange,
    isEditable,
    onConfirmingField,
    isConfirmed,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={{
                    ...truckOptions,
                    url: `${truckOptions.url}`,
                    filterResource: `filter[supplierId]=${supplierId}`,
                }}
                selectedValue={_.startCase(plateNumber)}
                onSelectChange={onChange}
                isEditable={isEditable}
                onConfirmingField={onConfirmingField}
                isConfirmed={isConfirmed}
            />
        </EuiFlexItem>
    );
}
